import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { Followers } from '@etop/models';
import { StateOAFollowers, OAFollowersStore } from './oa-follower.store';

@Injectable({
    providedIn: 'root',
})

export class OAFollowersQuery extends QueryEntity<StateOAFollowers, Followers> {
    constructor(protected store: OAFollowersStore) {
        super(store);
    }

    get currentUi() {
        return this.getValue().ui;
    }
}